import React from 'react';
import axios from 'axios';
import { reverbAffiliateUrl } from '../../utils/affiliateLinks';
import './WhereToBuy.css';

const API_URL = process.env.REACT_APP_API_URL ||
  (window.location.hostname === 'localhost' && window.location.port === '3002'
    ? 'http://localhost:3000/api'
    : '/api');

const WhereToBuy = ({ manufacturer, model, ampId, token }) => {
  const query = encodeURIComponent(`${manufacturer} ${model}`.trim());

  const reverbUrl = reverbAffiliateUrl(`https://reverb.com/marketplace?query=${query}`);

  const logClick = (destination) => {
    const api = axios.create({ baseURL: API_URL });
    if (token) api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    api.post('/activity/track', {
      action: 'marketplace_click',
      entity_type: 'amplifier',
      entity_id: ampId,
      entity_name: `${manufacturer} ${model}`,
      description: `Clicked Where to Buy: ${destination}`,
      metadata: { destination, manufacturer, model }
    }).catch(() => {});
  };

  return (
    <div className="where-to-buy">
      <h3 className="where-to-buy-title">Where to Buy</h3>
      <p className="where-to-buy-subtitle">Find a {manufacturer} {model} on the secondary market:</p>
      <div className="where-to-buy-buttons">
        <a
          href={reverbUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="wtb-btn wtb-btn-reverb"
          onClick={() => logClick('reverb')}
        >
          Shop on Reverb
        </a>
        {/* eBay button disabled — account suspended; re-enable when/if resolved
        <a
          href={ebayUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="wtb-btn wtb-btn-ebay"
          onClick={() => logClick('ebay')}
        >
          Shop on eBay
        </a>
        */}
      </div>
    </div>
  );
};

export default WhereToBuy;
